import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { EndPoint } from '../config/endpoint';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class AICreditPointsService {
  constructor(
    private httpService: HttpService,
    private router: Router,
  ) {}

  async getAICreditByUserId(param?: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.ai_credits_usage}`, {
          params: param,
        }),
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  async addCreditPoints(body: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.ai_credits_usage}`, body),
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }
  async editCreditPointsRecord(body: object, id: number) {
    try {
      const response = await firstValueFrom(
        this.httpService.put<any>(`${environment.XANO_SERVER_URL}${EndPoint.ai_credits_usage}/${id}`, body),
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getSubscriptionByUserId(param?: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.check_subscription_by_user_id}`, {
          params: param,
        }),
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
}
